<template>
  <div>
  <v-card>
    <v-toolbar card  light dense flat>
      <v-btn v-show="mode === 'page'" @click="$router.go(-1)" icon light>
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-scroll md flat :offset="calcOffset(52)">
      <v-card>  
        <!-- <div class="v-input">Документы</div> -->
        <template v-for="step in getChildrenListSteps">
        <v-card flat>
          <component
             :is="step.class || 'v-step-generator'"
             v-model=step.model
             v-bind="step.props"
             >
          </component>
        </v-card>
        </template>
      </v-card>
      <v-card v-if="actions && actions.length > 0"> 
        <v-panel-title @click="isAllActions = !isAllActions" :value="isAllActions" :caption="this.isAllActions ? 'Показать незавершенные' : 'Показать все'">
          <v-items-field
            label = "Журнал"
            :items = getScheduledActions()
            @click = "onActionClick($event)"
            smallIcons
          >
          </v-items-field>  
        </v-panel-title>
      </v-card>
      <v-stepper v-if="strategy.getSteps().length > 0" v-model="currentStep" vertical>
        <template v-for="step in strategy.getSteps()">
          <v-stepper-step :complete="complete(step)" :step="step.number" :editable="editable(step)">
            {{step.title}}
            <small v-if="step.subTitle"><span v-html="typeof step.subTitle === 'function' ? step.subTitle(step) : ''"></span></small>
          </v-stepper-step>
          <v-stepper-content :step="step.number">
            <v-card flat>
                <component
                   :is="step.class || 'v-step-generator'"
                   v-model=step.model
                   v-bind="step.props"
                   >
                </component>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!step.nextEnabled()" @click="next(step)">{{step.nextLabel()}}</v-btn>
                <v-btn flat :disabled="!step.backEnabled()" @click="back(step)">{{step.backLabel()}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </template>
      </v-stepper>
    </v-card-scroll>
    <v-card-actions>
      <v-btn v-show="previewable()" @click="preview(null, 'color')">Просмотр</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="dialogOpenAssistForm()">Атрибуты</v-btn>
    </v-card-actions>

  </v-card>

</div>
</template>

<script type="text/javascript">
  import formats from '../../api/formats'
  import server from '../../api/server.js'
  import { mapGetters } from 'vuex'
  import dialogs from '../common/dialogs'
  import client from '../client'
  import vDeedSelector from './DeedSelector'
  import vStepGenerator from './StepGenerator.vue'
  // import DeedSteps from './DeedSteps.js'
  import depo from '../depo'
  import vAssistForm from './AssistForm'
  import vItemsField from '../common/ItemsField'
  import apimix from '../common/apimix'
  import profile from '../profile/index.js'
  import vPanelTitle from '../info/PanelTitle'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'assist-package',
    components: {vStepGenerator, vItemsField, vPanelTitle, vCardScroll},
    mixins: [apimix],
    data: () => ({
      currentStep: 0,
      edit: false,
      valid: false,
      isProcessing: false,
      isAllActions: false,
      item: {},
      actions: [],
      depos: [],
      strategy: {},
      mode: 'page'
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      typeCode: {
        type: String,
        default: 'DEED'
      }
    },
    created () {
      this.strategy = this.getAssistMatterStrategy(this.typeCode, this)
      this.fetchData(this.itemId)
      this.$store.dispatch('fetchRights', {SEND_MAIL: null})
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        this.fetchData(newVal)
        this.$store.dispatch('fetchRights', {SEND_MAIL: null})
      }
    },
    computed: {
      ...mapGetters({
        profile: 'getProfile',
        calcDialogOfs: 'calcDialogOfs',
        calcOfs: 'calcOfs',
        getIsAllow: 'getIsAllow',
        getAssistMatterTypes: 'getAssistMatterTypes',
        getAssistMatterStrategy: 'getAssistMatterStrategy',
        getNewAssistMatter: 'getNewAssistMatter',
        getAssistDeedsByPath: 'getAssistDeedsByPath',
        getDepoCurrentPath: 'getDepoCurrentPath',
        getClientUrl: 'getClientUrl',
        getDepoUrl: 'getDepoUrl'
      }),
      title () {
        return this.item && this.item.name ? this.item.name : (!this.itemId && this.typeCode ? this.getAssistMatterTypes().get(this.typeCode) : '')
      },
      getChildrenListSteps () {
        return this.strategy && this.strategy.childrenStep && [this.strategy.childrenStep] || []
      }
    },
    methods: {
      getMatterId () {
        return this.item && this.item.id || this.itemId || null
      },
      getScheduledActions () {
        let fstrategy = profile.createStrategy(this, 'ACTION')
        if (!fstrategy) {
          return
        }
        let actions = this.isAllActions ? this.actions : this.actions.filter(al => (al.scheduled && !al.finished) || (al.finished && al.resultCode === 'PROCESS'))
        return actions.map(al => {
          let model = fstrategy.createModelFromData(al)
          let icon = al.started && al.resultCode || al.scheduled && 'SCHEDULE'
          return {
            title: fstrategy.viewTitle(model),
            date: al.finished || al.scheduled || al.started,
            text: fstrategy.viewContentListComp(model),
            icons: [icon],
            time: al.finished || al.scheduled || al.started,
            id: al.id
          }
        }).sort((b, a) => a.time - b.time)
      },
      onActionClick (item) {
        profile.openLogAction(item.id, this.getMatterId())
      },
      // Format methods
      calcOffset (off, offModal) {
        return this.calcOfs(off, offModal)
      },
      // Controller Methods
      next (step) {
        this.strategy.next(this.item.model, step)
      },
      back (step) {
        this.strategy.back(this.item.model, step)
      },
      complete (step) {
        return this.strategy.complete(this.item.model, step)
      },
      editable (step) {
        return this.strategy.editable(this.item.model, step)
      },
      previewable () {
        return !this.strategy.previewable || this.strategy.previewable(this.item.model)
      },
      // Model methods
      updateModel (model) {
        console.log('updateModel', model)
        this.item.model = model
        this.strategy.updateModel(model)
        this.currentStep = model.getCurrentStep()
        this.$forceUpdate()
      },
      getItemNew () {
        var item = this.getNewAssistMatter({typeCode: this.strategy.getTypeCode(), model: this.strategy.createModel()})
        return item
      },
      fetchData (itemId) {
        if (itemId) {
          this.$store.dispatch('getAssistScheme', itemId).then(
            (scheme) => {
              this.strategy.updateSteps(scheme)
              this.$store.dispatch('getAssistMatter', itemId).then(
                (item) => {
                  this.item = item
                  var model = Object.assign(this.strategy.createModel(), this.item.model)
                  this.updateModel(model)
                },
                () => {}
              )
            },
            () => {})
          this.fetchActions()
        } else {
          this.strategy.updateSteps(null)
          this.item = this.getItemNew()
          this.updateModel(this.item.model)
        }
      },
      fetchActions () {
        let itemId = this.itemId || (this.item && this.item.id)
        this.$store.dispatch('getAssistMatterActions', itemId).then(
          (actions) => { this.actions = actions })
      },
      updateData (model, cb) {
        this.item.model = model
        this.$store.dispatch('updateAssistMatter', this.item).then(
          () => {
            this.fetchData(this.item.id)
            if (cb) {
              cb()
            }
          },
          () => {}
          )
      },
      refreshData () {
        if (this.itemId) {
          this.fetchData(this.itemId)
        } else {
          if (this.item) {
            this.fetchData(this.item.id)
          }
        }
      },
      // Action methods
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      preview (format, color) {
        const cb = () => this.print(/xml|rtf|docx/.test(format) ? format : null, null, color)
        this.updateData(this.item.model, cb)
      },
      print (format, data, color) {
        var formatStr = format ? '&format=' + format : ''
        var colorStr = color ? '&color=1' : ''
        var dataStr = data ? '&data=' + data : ''
        let url = server.getBaseUrl() + '/openapi/assist/matters/' + this.item.id + '/reports_redirect?' + formatStr + colorStr + dataStr
        this.$store.dispatch('openLocation', url)
      },
      macro (macro) {
        let request = {id: this.item.id, macro: macro}
        return this.$store.dispatch('macroAssistMatter', request)
      },
      send (macro, mailbox) {
        let request = {id: this.item.id, macro: macro, mailbox: mailbox}
        return this.$store.dispatch('sendAssistMatter', request)
      },
      calcMailbox (name) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('getClientMailboxes').then(mbs => {
            if (name) {
              name = name.toLowerCase()
              resolve(mbs.reduce((accumulator, curValue) => curValue.name && formats.compareString(name, curValue.name) === 0 ? curValue.name : accumulator, ''))
            } else {
              resolve(mbs.length > 0 && mbs[0].name || null)
            }
          })
        })
      },
      openDepo (depoId) {
        this.$store.dispatch('getDepoFileVersions', depoId)
        .then((fs) => fs[0])
        .then(fileItem => fileItem && fileItem.uid ? this.getDepoUrl(fileItem.uid) + '/stream' : null)
        .then(url => url ? this.$store.dispatch('openLocation', url) : null)
      },
      saveAsNew (model) {
        var item = this.getItemNew()
        item.model = model
        this.$store.dispatch('updateAssistMatter', item).then(
          () => {
            this.fetchData(item.id)
          },
          () => {}
          )
      },
      delete () {
        dialogs.confirm(this,
        'Подтвердите',
        `Удалить дело?`,
        (self) => {
          self.$store.dispatch('deleteAssistMatters', {ids: [self.item.id]})
          self.cancel()
        })
      },
      selectCompany (fieldName, onChange) {
        const setItem = (values) => {
          console.log('setItem', values)
          if (Array.isArray(values) && values.length > 0) {
            var model = this.item.model
            if (model[fieldName] !== values[0].ref) {
              if (onChange) {
                onChange(model, fieldName, values[0].ref)
              }
              model[fieldName + '_CODE'] = values[0].ref
              model[fieldName] = values[0].inn
              model[fieldName + 'DESCRIPTION'] = values[0].caption
              model.setCurrentStep(this.currentStep)
              this.updateModel(model)
            }
          }
        }
        const getQuery = () => this.item.model[fieldName] ? this.item.model[fieldName].toString() : ''
        client.selectRef(this, setItem, getQuery, true, true)
      },
      setDeed (valueFieldName, textFieldName, value, prefix) {
        let deedNumber = value.toUpperCase()
        if (/^\d+$/.test(deedNumber)) {
          deedNumber = prefix ? prefix + deedNumber : 'DEED:' + deedNumber
        }
        var model = this.item.model
        model.setCurrentStep(this.currentStep)
        this.$store.dispatch('getAssistDeed', deedNumber).then(deed => {
          model[valueFieldName] = deed.id
          model[textFieldName] = deed && deed.name || null
          this.updateModel(model)
        })
      },
      selectDeed (valueFieldName, textFieldName, bindersOnly) {
        const setItem = (value) => {
          this.setDeed(valueFieldName, textFieldName, value)
        }
        const getQuery = () => this.item.model[valueFieldName]
        dialogs.register('v-deed-selector', vDeedSelector)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-deed-selector v-on:close="$emit('close')"
          v-on:input="setItem"
          :bindersOnly="bindersOnly"
          :fullscreen="fullscreen" radio :query="getQuery()"></v-deed-selector>
          `,
          data () {
            return {
              fullscreen: fullscreen,
              setItem: setItem,
              getQuery: getQuery,
              bindersOnly: bindersOnly
            }
          }
        }
        dialogs.modal(comp)
      },
      getDeedFormats () {
        return [
          {value: 'docx', text: 'DOCX'},
          {value: 'pdf', text: 'PDF'},
          {value: 'rtf', text: 'RTF'},
          {value: 'xml', text: 'XML'}
        ]
      },
      getDepoFileProps (uids, cb) {
        if (uids && Array.isArray(uids)) {
          this.$store.dispatch('getDepoFileProps', {uids: uids}).then(
                  (data) => cb(data),
                  () => {}
          )
        } else {
          cb([])
        }
      },
      attachDocs (fieldName, queryCxt) {
        const onSelect = (values) => {
          if (Array.isArray(values)) {
            var model = this.item.model
            let set = new Set(values)
            formats.splitDepoUids(model[fieldName]).forEach(v => {
              set.add(v)
            })
            model[fieldName] = Array.from(set).sort((a, b) => a - b).join(', ')
            model.setCurrentStep(this.currentStep)
            this.updateModel(model)
          }
        }
        depo.selectDoc(this, onSelect, true, queryCxt)
      },
      selectDocs (fieldName, items, title) {
        const onSelect = (values) => {
          if (Array.isArray(values)) {
            var model = this.item.model
            let set = new Set(values)
            // formats.splitDepoUids(model[fieldName]).forEach(v => {
            //   set.add(v)
            // })
            model[fieldName] = Array.from(set).sort((a, b) => a - b).join(', ')
            model.setCurrentStep(this.currentStep)
            this.updateModel(model)
          }
        }
        let valueStr = this.item.model[fieldName]
        depo.selectDocProp(this, onSelect, items, formats.splitDepoUids(valueStr), title)
      },
      loadDocs (fieldName, fieldPathName) {
        const setDocs = (values) => {
          if (Array.isArray(values) && values.length > 0) {
            var model = this.item.model
            let set = new Set(values)
            formats.splitDepoUids(model[fieldName]).forEach(v => {
              set.add(v)
            })
            model[fieldName] = Array.from(set).sort((a, b) => a - b).join(', ')
            model.setCurrentStep(this.currentStep)
            this.updateModel(model)
          }
        }
        let path = this.item.model[fieldPathName]
        depo.newFile(path, setDocs)
      },
      openDoc (valueFieldName) {
        let uid = this.item.model[valueFieldName]
        const onNewVersion = () => {
          depo.newFile(this.getDepoCurrentPath, null, uid)
        }
        if (uid) {
          if (formats.isDepoUid(uid)) {
            depo.openFile(uid, this.getDepoCurrentPath, false, onNewVersion)
          }
        }
      },
      depoDoc (valueFieldName) {
        const depoAssistMatter = (id, depoPrevUid) => {
          this.item.model[valueFieldName] = null
          this.item.model[valueFieldName + 'Action'] = 'NONE'
          this.$store.dispatch('depoAssistMatter', {id: id, depoPrevUid: formats.isDepoUid(depoPrevUid) ? depoPrevUid : null}).then(
            (data) => {
              this.refreshData()
            },
            () => {
              this.item.model[valueFieldName + 'Action'] = null
            })
        }
        let actionLogId = this.item.model[valueFieldName + 'Action']
        if (actionLogId === 'NONE') {
          return
        }
        let prevUid = this.item.model[valueFieldName]
        if (actionLogId) {
          dialogs.confirm(this,
            'Подготовка документа еще не завершена.',
            `Начать создание нового?`,
            () => depoAssistMatter(this.item.id, prevUid)
          )
        } else {
          depoAssistMatter(this.item.id, prevUid)
        }
      },
      dialogOpenAssistForm () {
        var self = this
        const onInput = function (data) {
          self.fetchData(self.item.id)
        }
        const onDelete = function (data) {
          self.delete(self.item.id)
        }
        dialogs.register('v-assist-form', vAssistForm)
        var comp = { template: `
          <v-assist-form v-on:input="onInput" v-on:delete="onDelete" v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-assist-form>
        `,
          data () {
            return {
              model: {id: self.item.id, name: self.item.name, notes: self.item.notes},
              onInput: onInput,
              onDelete: onDelete,
              fullscreen: self.$vuetify.breakpoint.xsOnly
            }
          }
        }
        dialogs.modal(comp)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// AssistPackage.vue?83b66e30